import Grid from 'components/Grid'
import ThingCard from 'components/ThingCard'
import { MbPagination, MbThingCard } from 'mintbase-ui'
import { MarketRelation } from 'types/indexer'
import { useLatestListingsController } from '../controllers/LatestListings.controller'
import { FilterOptions } from '../types/Marketplace.type'

const LoadingLists = ({ itemsPerPage }: { itemsPerPage }) => {
  const lists = Array.from(Array(itemsPerPage).keys())
  return (
    <>
      {lists.map(() => (
        <MbThingCard loading={true} key={''} cardInfo={null} />
      ))}
    </>
  )
}

const LatestListings = ({
  filter = FilterOptions.NEWEST,
  page: initialPageIndex,
  ssrData,
}: {
  filter: FilterOptions
  page: number
  ssrData: MarketRelation[]
}) => {
  const { data, loading, setCurrentPage, itemsPerPage, page, totalItems } =
    useLatestListingsController({
      filter,
      initialPageIndex,
      initialSSRData: ssrData,
    })

  return (
    <>
      <Grid>
        {loading && <LoadingLists itemsPerPage={itemsPerPage} />}
        {!loading &&
          data?.map((ele, index) => {
            return (
              <ThingCard
                key={`${ele.id}-${index}`}
                id={ele.thing.id}
                title={ele?.thing?.metadata?.title || ''}
                coverImage={ele?.thing?.metadata?.media || ''}
              ></ThingCard>
            )
          })}
      </Grid>
      <MbPagination
        currentPage={page + 1}
        hasLabel
        itemsPerPage={itemsPerPage}
        onPageChange={(nextPage) => setCurrentPage(nextPage - 1)}
        totalItems={totalItems}
      />
    </>
  )
}

export default LatestListings
